import { RouteExportDto, RowRouteDto } from "@/dtos";
import { Route } from "@/entities";
import { getRouteOrientationLabel, getRouteRoadTypeLabel, getRouteVehicleTypeLabel } from "@/helpers/options";

const validateRouteConfig = (route: Route) => {
    if (route.tripPattern.length > 0) {
        if (route.tripPattern.some(x => 
            x.trip_pattern_checkpoints.length > 0 && 
            x.trip_pattern_checkpoints.some(y => y.time_between_checkpoints > 0))
        ) {
            return true;
        }
        return false;
    }
    return false
}

export const formatRowRouteDto = (routes: Route[]): RowRouteDto[] => {
    return routes.map((x) => {

        const row: RowRouteDto = {
            ...x,
            orientation_label: getRouteOrientationLabel(x.orientation),
            road_type_label: getRouteRoadTypeLabel(x.road_type),
            vehicle_type_label: getRouteVehicleTypeLabel(x.vehicle_type),
            route_group_name: x.routeGroup.name,
            is_config_label: validateRouteConfig(x) ? 'Completa' : 'Incompleta',
            active: (x.is_active) ? 'Activo' : 'Inactivo'
        }
        return row;
    });
} 

export const formatRouteExportDto = (routes: Route[]): RouteExportDto[] => {
    return routes.map((x) => {
        const row: RouteExportDto = {
            ...x,
            orientation_label: getRouteOrientationLabel(x.orientation),
            road_type_label: getRouteRoadTypeLabel(x.road_type),
            vehicle_type_label: getRouteVehicleTypeLabel(x.vehicle_type),
            active: (x.is_active) ? 'Activo' : 'Inactivo',
            is_primary_label: (x.is_primary) ? 'Si' : 'No',
            color_icon: x.color.icon ?? '',
            color_text: x.color.text ?? '',
            color_outline: x.color.outline ?? ''
        }
        return row;
    });
}